var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOctagon = function SvgOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9B51E0",
    strokeWidth: 1.5,
    d: "M6.522 1.01a1.25 1.25 0 0 1 .956 0l3.42 1.416c.306.127.549.37.676.677l1.416 3.419c.127.306.127.65 0 .956l-1.416 3.42a1.25 1.25 0 0 1-.677.676L7.478 12.99a1.25 1.25 0 0 1-.956 0l-3.42-1.416a1.25 1.25 0 0 1-.676-.677L1.01 7.478a1.25 1.25 0 0 1 0-.956l1.416-3.42c.127-.306.37-.549.677-.676z"
  })));
};
export default SvgOctagon;